import React from "react";

function TrafficHomeOne({ className }) {
  return (
    <section className={`appie-service-area pt-140 pb-50 ${className || ""}`}>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="appie-traffic-title" style={{ paddingRight: 0 }}>
              <h3 className="title text-center">GENERAL RULES</h3>
              <ul>
                <li>
                  • Smoking and hookah are strictly prohibited within the
                  premises.
                </li>
                <li>
                  • The consumption of alcohol is not allowed within the
                  premises.
                </li>
                <li>• Only JAIN food will be served.</li>
                <li>
                  • Participants are required to wear appropriate footwear;
                  slippers are not allowed within the premises
                </li>
                <li>
                  • Check-in and check-out time is 12 noon. However, we will
                  make efforts to accommodate early check-ins.
                </li>
                <li>
                  • Please keep your room keys safe. In case of loss, a fee of
                  1500 will be charged.
                </li>
                <li>
                  • Entry to Flame University premises is restricted after 10
                  pm.
                </li>
                <li>
                  • The organizers will not be held responsible for any
                  incidents, mishaps, or loss of property on or off the field.
                </li>
                <li>
                  • Any damages to the property will be the responsibility of
                  the respective city/chapter and will be recovered accordingly.
                </li>
                <li>
                  • Please remember to bring your own towels and dental kits.
                </li>
                <li>
                  • Any form of misbehavior will not be tolerated and may result
                  in appropriate action being taken.
                </li>
              </ul>
            </div>
          </div>
          <div className="col-12">
            <div className="appie-traffic-title" style={{ paddingRight: 0 }}>
              <h3 className="title text-center">COMMON SPORTS RULES</h3>
              <ul>
                <li>
                  <strong>
                    • As many players are participating in multiple games, the
                    management would like to clarify that it will not be held
                    responsible for any clashes in match schedules. In the event
                    of such clashes, matches will not be put on hold or
                    postponed. Instead, the opponent will be granted a bye.
                  </strong>
                </li>
                <li>
                  • Participants must identify as Jain and be between the ages
                  of 18 and 36. Failure to meet these criteria will result in
                  disqualification from the tournament, and no replacements will
                  be allowed.
                </li>
                <li>
                  • All participants must be in reasonable health and fitness to
                  participate in the specific events.
                </li>
                <li>
                  • On-field decisions made by judges, organizers, referees, and
                  umpires will be final.
                </li>
                <li>
                  • The event schedule and venues will be determined by the
                  steering committee and will be final and binding. Any changes
                  in date or venue made by the organizers due to unforeseen
                  circumstances must be accepted by the participants.
                </li>
                <li>
                  • Participants must wear the official T-shirts/Jerseys
                  provided by the organizing committee during all events.
                </li>
                <li>
                  • The events will be completed within the stipulated time
                  based on the number of participants. Participants may need to
                  play multiple rounds on any given day.
                </li>
                <li>
                  • All teams are expected to maintain discipline and avoid
                  arguments with other participants and referees.
                </li>
                <li>
                  • The organizing team reserves the right to reject any
                  participant for using unfair means or displaying improper
                  conduct on or off the field.
                </li>
                <li>
                  • If a participant fails to arrive at the venue within 15
                  minutes of their scheduled match time, a bye will be granted
                  to the opponent.
                </li>
                <li>
                  • Sports equipment must be returned to its proper place after
                  use.
                </li>
                <li>
                  • Players are responsible for the safety of their sports
                  equipment, sports attire, and personal belongings.
                </li>
                <li>
                  • The grouping of teams and individual players in the
                  respective sports has been done by the management committee
                  after obtaining approval from everyone during the Virtual
                  co-ordinators Meeting. This grouping takes into account the
                  multi-sport scheduling factor. No objections will be
                  entertained against the assigned groups.
                </li>
                <li>
                  • Players who feel unwell while playing should immediately
                  stop playing and seek assistance from our medical team.
                </li>
                <li>
                  • Only non-marking shoes should be worn in the playing area.
                  Athletic shoes with black soles are prohibited. Bare feet,
                  heels, flip flops, sandals, and any other type of footwear are
                  not allowed.
                </li>
                <li>
                  • Food, hot drinks, and glass drink bottles are not allowed in
                  the playing areas.
                </li>
                <li>
                  • The decision of the Steering Committee shall be final in all
                  matters.
                </li>
                <li>
                  • The management reserves the right to change, modify, or
                  amend the rules and guidelines as necessary.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TrafficHomeOne;
